import type {
  TodoListConfig,
  TodoListDayData,
  WidgetConfig,
  WidgetWeekEntry,
} from "@/lib/schema";
import { countPhrase, sumOverDays } from "@/widgets/describe";
import { getWidgetModule } from "@/widgets/registry";
import type { DayWidgetModule } from "@/widgets/types";
import { DayView } from "./DayView";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";

function defaults(existing: WidgetConfig[]): TodoListConfig {
  const dayWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "day",
  );
  const maxRow = dayWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "todo-list",
    label: "Huskeliste",
    row: maxRow + 1,
    column: 0,
    enabled: true,
  };
}

// Every item, ticked or not — an unticked todo is the one most worth keeping.
function describeWeekData(entry: WidgetWeekEntry): string | null {
  const todos = sumOverDays<TodoListDayData>(
    entry,
    (day) => day?.todos?.length ?? 0,
  );
  return countPhrase(todos, "gjøremål", "gjøremål");
}

export const todoList: DayWidgetModule<TodoListConfig> = {
  kind: "todo-list",
  label: "Huskeliste",
  scope: "day",
  scoring: "none",
  defaults,
  validate,
  SettingsEditor,
  DayView,
  describeWeekData,
};
